import { openClientDownload, prefetchClientDownload, showDownloadNotice } from '@/utils/download'
import { detectUaPlatform } from '@/utils/device'
import { withInviteQuery } from '@/utils/channel'
import { openIosLogin } from '@/utils/login'

const PLATFORM_MAP = {
  Windows: 'windows',
  Android: 'android',
  iOS: 'ios',
  Mac: 'macos',
  windows: 'windows',
  android: 'android',
  ios: 'ios',
  macos: 'macos',
}

function detectButtonType() {
  const platform = detectUaPlatform()
  if (platform === 'windows') return 'Windows'
  if (platform === 'android') return 'Android'
  if (platform === 'ios') return 'iOS'
  if (platform === 'macos') return 'Mac'
  return 'Windows'
}

export default {
  data() {
    return {
      type: 'Windows',
      deviceType: 'android',
      downloading: false,
    }
  },
  mounted() {
    this.type = detectButtonType()
    this.deviceType = this.type === 'iOS' ? 'ios' : 'android'
    prefetchClientDownload()
    window.addEventListener('resize', this.detectDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectDevice)
  },
  methods: {
    detectDevice() {
      this.type = detectButtonType()
      this.deviceType = this.type === 'iOS' ? 'ios' : 'android'
    },
    toUrl(url, event) {
      if (event && event.preventDefault) event.preventDefault()
      const map = { '/terms': '/termservice', promotion: '/promotion', '/promoters': '/promotion' }
      const target = map[url] || (url.charAt(0) === '/' ? url : `/${url}`)
      if (this.$route.path !== target) {
        this.$router.push({ path: target, query: withInviteQuery(this.$route.query) }).catch(() => {})
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      }
    },
    goUrl(name) {
      this.toUrl(name)
    },
    async downloadKP(device) {
      if (this.downloading) return
      const platform = PLATFORM_MAP[device]
      if (!platform) {
        showDownloadNotice('不支持设备')
        return
      }
      this.downloading = true
      try {
        if (platform === 'ios') {
          openIosLogin()
        } else {
          await openClientDownload(platform)
        }
      } finally {
        this.downloading = false
      }
    },
    godown(device) {
      return this.downloadKP(device)
    },
  },
}
